module.exports = __webpack_public_path__ + "img/common.278ed43.png";